// @flow strict

import { NAVIGATION_ROUTES, USERS_CLIENTS_PLANTS_NAVIGATION_ROUTES } from 'utils/constants';

const getCircuitDashboardUrl = (plantId: number, circuitId: number) => {
    // computed as: /plant/123/circuit/456
    return `${NAVIGATION_ROUTES.PLANT}${plantId}${NAVIGATION_ROUTES.CIRCUIT}${circuitId}`;
};

const getPlantEditorUrl = (plantId: number, circuitId: number) => {
    // computed as: /management/plants/123
    return `${USERS_CLIENTS_PLANTS_NAVIGATION_ROUTES.PLANTS}/${plantId}`;
};

const getPlantDashboardUrl = (plantId: number) => {
    // computed as: /plant/123
    return `${NAVIGATION_ROUTES.PLANT}${plantId}`;
}

export const SolvExtractNavigation = {
    getCircuitDashboardUrl,
    getPlantDashboardUrl,
    getPlantEditorUrl,
};
